import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';
import { TPowerPlantPropertyType } from '@brickwise/asset-validation/dist/schema/enums';

interface Props {
  disabled: boolean;
}

export const PowerplantPropertyTypeSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const optionToLabelKeyMap: Record<TPowerPlantPropertyType, Parameters<typeof t>[0]> = {
    photovoltaic: 'general.powerplanttype.solar.label',
    wind: 'general.powerplanttype.wind.label',
    bundle: 'general.powerplanttype.bundle.label',
    storage: 'general.powerplanttype.storage.label',
  };

  return (
    <DefaultFastSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.propertyoverview.fields.propertyType.label')}
      fieldName="propertyDetails.powerplantType"
      options={Object.entries(optionToLabelKeyMap).map(([value, labelKey]) => {
        return {
          value,
          label: t(labelKey as any),
        };
      })}
    />
  );
};
